
const rutasMapasSVG = [
//SVG
/*{
    name: "svg_arbustos_posicion",
    type: "svg",
    path: "mapa/arbustos_posicion.svg",
  },*/
  {
    name: "svg_base",
    type: "svg",
    path: "mapa/base.svg",
  },
  {
    name: "svg_arbolesTest",
    type: "svg",
    path: "mapa/arboles_test_posicion.svg",
  },
  {
    name: "svg_arbustos_posicion",
    type: "svg",
    path: "mapa/arbustos_posicion.svg",
  },
  {
    name: "svg_arboles_posicion",
    type: "svg",
    path: "mapa/arboles_posicion.svg",
  },
  {
    name: "svg_arboles_relleno_posicion",
    type: "svg",
    path: "mapa/arboles_relleno_posicion.svg",
  },
  {
    name: "svg_personas_posicion",
    type: "svg",
    path: "mapa/personas_posicion.svg",
  },
  
]

export default rutasMapasSVG